import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Grid,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  grey,
} from '@material-ui/core/colors';

import { a11yProps } from '../helpers';
import { selectCurrentCompany } from '../store/companySlice';
import TabPanel from '../components/common/TabPanel';
import CompanyGrid from '../components/tables/CompanyGrid';
import CompanySelectForm from '../components/forms/CompanySelectForm';
import ReservationImportForm from '../components/forms/ReservationImportForm';

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tabContainer: {
    borderBottomColor: grey[400],
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
}));

export default function Admin() {
  const classes = useStyles();
  const currentCompany = useSelector(selectCurrentCompany);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid item xs={12}>
      <Box className={classes.root}>
        <Box className={classes.tabContainer}>
          <Tabs value={value} onChange={handleChange} aria-label="Admin Modules">
            <Tab label="Company Grid" {...a11yProps(0)} />
            <Tab label="Import Reservations" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <CompanyGrid />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CompanySelectForm />
          <ReservationImportForm clientId={currentCompany?.clientId} />
        </TabPanel>
      </Box>
    </Grid>
  );
}
